import React, { useState } from 'react'
import { compose } from 'recompose'
import { makeStyles } from '@material-ui/core/styles'
import { injectIntl } from 'react-intl'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { Container, Grid } from '@material-ui/core'
import LineChart from './LineChart'
import BarChart from './BarChart'
import Button from '@material-ui/core/Button'
import InfoIcon from '@material-ui/icons/Info';
import ReactVisibilitySensor from 'react-visibility-sensor'
import { connect } from 'react-redux'
import { markScoresAsRead } from '../../../../redux/actions'
import { caseSelector } from '../../../../redux/selectors'
import * as cookies from '../../../../utilties/cookies'
import clsx from 'clsx'
import trademarkImg from '../../../../assets/trademark-svg.svg'

const COLOR_MYRESULTS = '#057AFE'
const COLOR_ALLRESULTS = '#010E23'
const MAX_CHARS = 300

const useStyles = makeStyles((theme) => ({
	chartOuterWrapper: {
		position: 'relative',	
	},
	gridInner: {
		padding: '0',
		margin: '0 -24px 30px -24px',
		width: 'calc(100% + 24px)',
        overflowY: 'hidden',
		[theme.breakpoints.down('sm')]: {
            margin: '-12px -40px 0 -40px',
			width: '100vw',
        },
	},
	chartGraph: {
		
		[theme.breakpoints.down('sm')]: {
			overflow: 'auto',
        },
	},
	label: {
		color: '#9C9DA1',
		fontSize: '17px'
	},
	buttonRoot: {
		[theme.breakpoints.down('sm')]: {
			margin: '15px 0 12px'
        }
	},
	buttonMoreLess: {
		margin: '3px 0',
	},
	circle: {
		width: 10,
		height: 10,
		borderRadius: 5
	},
	myResultsCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: COLOR_MYRESULTS,
		display: 'inline-block'
	},
	allResultsCircle: {
		backgroundColor: COLOR_ALLRESULTS,
		display: 'inline-block'
	}
}))

const SurveyResponseList = ({ item, intl, currentCase, markAsRead, benchmarcs }) => {
	const classes = useStyles()
	const [ showAbout, setShowAbout ] = useState(true)
	const [ subShowAbout, setSubShowAbout ] = useState(false)
	const [ markAsReadTimer, setMarkAsReadTimer] = useState(null)
	const [ markAsReadSent, setMarkAsReadSent] = useState(false)

	const [patient] = useState(cookies.get('user'))

	const onMarkAsRead = () => {
		setMarkAsReadSent(true)
		markAsRead(currentCase.patientId, currentCase.id, item.scoringGroupId)
	}

	const onVisibilityChange = (isVisible) => {
		if (!patient.externalAuth && !markAsReadSent && item && item.coordinates && item.coordinates.find(({ completed, isRead }) => completed && !isRead)) {
			if (isVisible) {
				setMarkAsReadTimer(setTimeout(() => onMarkAsRead(), 3000))
			} else {
				clearTimeout(markAsReadTimer)
			}
		}
	}

	return (
		<Container maxWidth="lg" className={classes.chartOuterWrapper}>

			<Grid container style={{marginTop: '41px'}}>
				<Grid item xs={12}>
					{item.coordinates.find(({ completed, isRead }) => completed && !isRead) && 
					<Grid item xs={12}>
						<span data-testid="survey-response-results-new-score" className="survey-response-results-new-score" style={{
							backgroundColor: '#007e6a',   
							color: '#fff',
							padding: '1px 6px 2px',
							fontWeight: 'bold',
							borderRadius: '4px', fontSize: '12px', textTransform: 'uppercase', margin: '4px 5px 0 0', float: 'left'
						}}>{intl.formatMessage({
							id: 'app.chart.newScoreHeader'
						})}</span>
					</Grid> }
					<Grid item xs={12} >
						<Grid container style={{alignItems: 'center', justifyContent: 'space-between'}}> 
							<Grid item>
								<Typography
									data-testid="survey-score-label"
									variant='h2'
									style={{ fontSize: '30px', color: '#000', paddingRight: '20px' }}>
									{item.scoringGroupName}
								</Typography>
							</Grid>
							{/* <Grid item style={{ alignSelf: 'center' }}>
								<Button
									data-testid="button-show-about"
									data-print="none"
									className={classes.buttonRoot}
									variant="contained"
									color="primary"
									endIcon={<InfoIcon />}
									onClick={() => setShowAbout(!showAbout)}>
									{intl.formatMessage({ id: 'app.chart.aboutText' })}
								</Button>
							</Grid> */}

						</Grid>

						<Grid container>

							{/* <Grid item xs={12}>
							{item.scoringGroupDescription &&
								item.scoringGroupDescription.length > 0 && (
										<Grid item>
											{showAbout && (
												<Grid style={{ padding: '8px 0px' }}>
													{item.scoringGroupDescription && (
														<div>
															{!subShowAbout && (
																<Typography
																	data-testid="scoring-group-desc-hidden"
																	style={{ fontSize: '17px', paddingBottom: '8px' }}>
																	{item.scoringGroupDescription.substring(0, MAX_CHARS)}
																</Typography>
															)}
															{subShowAbout && (
																<Typography
																	data-testid="scoring-group-desc-show"
																	style={{ fontSize: '17px', paddingBottom: '8px' }}>
																	{item.scoringGroupDescription}
																</Typography>
															)}
															{item.scoringGroupDescription.length >
																MAX_CHARS && (
																	<Button
																		data-testid="button-show-scoring-group"
																		variant="contained"
																		color="primary"
																		size="small"
																		className={classes.buttonMoreLess}
																		onClick={() =>
																			setSubShowAbout(!subShowAbout)}>
																		{!subShowAbout && (
																			<span style={{ fontSize: '14px' }}>
																				{intl.formatMessage({ id: 'app.chart.moreText' })}
																			</span>
																		)}
																		{subShowAbout && (
																			<span
																				data-testid="show-about-text"
																				style={{ fontSize: '14px' }}>
																				{intl.formatMessage({ id: 'app.chart.lessText' })}
																			</span>
																		)}
																	</Button>
																)}
														</div>
													)}
													{!item.scoringGroupDescription && (
														<Typography data-testid="scoring-group-no-text" style={{ fontSize: '17px' }}>
															{intl.formatMessage({ id: 'app.chart.noContentText' })}
														</Typography>
													)}
												</Grid>
											)}
										</Grid>
								)}
							
							</Grid> */}

						</Grid>

						<Grid container className={clsx(classes.chartGraph, `chartGraph`)}>
							<Grid item xs={12} >

								{/* {item.coordinates.length < 5 && (
									<BarChart data-testid="survey-response-barchart" data={item.coordinates} min={item.minScore} max={item.maxScore} />
								)}
								{item.coordinates.length >= 5 && (
									<LineChart data-testid="survey-response-linechart" data={item.coordinates} min={item.minScore} max={item.maxScore} />
								)} */}

								<ReactVisibilitySensor onChange={onVisibilityChange}>
									<LineChart
										data-testid="survey-response-linechart"
										data={item.coordinates}
										min={Math.min(item.minScore, benchmarcs && !isNaN(benchmarcs.minValue) ? benchmarcs.minValue : item.minScore)}
										max={Math.max(item.maxScore, benchmarcs && !isNaN(benchmarcs.maxValue) ? benchmarcs.maxValue : item.maxScore)}
										upperBound={item.upperBound}
										lowerBound={item.lowerBound}
										benchmarcs={benchmarcs}
									/>
								</ReactVisibilitySensor>
							</Grid>
						</Grid>
						
						{item.scoringGroupDisclaimer && item.showScoringGroupDisclaimer &&
							<Grid container direction='row' style={{ borderRadius: "5px", border: '1px solid', padding: '10px', display: 'flex', marginBottom: '20px' }}>
								<Grid item>
									<div style={{
										background: '#5ea510',
										padding: '5px',
										marginRight: '6px',
										borderRadius: '50%',
										width: '22px',
										height: '22px'
									}}>

									</div>
								</Grid>
								<Grid item style={{ flex: 1 }}>
									<Typography
										data-testid="survey-response-your-results-label"
										variant='body2'>
											<span style={{ fontWeight: 700 }}>
											{intl.formatMessage(
												{ id: "app.chart.scoringGroupDescriptionLabel" },
												{
												TMimg: (
													<img
													alt="TM"
													src={trademarkImg}
													style={{ width: "12px", paddingBottom: "3px" }}
													/>
												),
												}
											)}
											</span> {item.scoringGroupDisclaimer}																			
									</Typography>
								</Grid>
							</Grid>
						}
						<Grid container direction='row' style={{ borderRadius: "5px", border: '1px solid', padding: '10px', display: 'flex' }}>
							<Grid item>
								<div style={{
										background: '#2d67d8',
										padding: '5px',
										marginRight: '6px',
										borderRadius: '50%',
										width: '22px',
										height: '22px'
									}}>

								</div>
								</Grid>
								<Grid item style={{flex: 1}}>
								<Typography
									data-testid="survey-response-your-results-label"
									variant='body2'>
									<span style={{ fontWeight: 700 }}>{intl.formatMessage({ id: 'app.chart.scoringGroupResultsLabel' })}</span> {item.scoringGroupDescription}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>

		</Container>

	)
}

const mapStateToProps = (state) => ({
	currentCase: caseSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    markAsRead: (patientId, caseId, scoringGroupId) => dispatch(markScoresAsRead(patientId, caseId, scoringGroupId))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(SurveyResponseList)
